<template>
    <van-popup
        :close-on-click-overlay="false"
        style="background: transparent"
        :value="show">
        <div class="main">
            <img src="./img/guide.png" alt="">
            <div class="know" @click="writeMark"></div>
        </div>
    </van-popup>
</template>
<script>
    import { Popup  as vanPopup } from 'vant'
    export default {
        props: {
            mark: {
                type: String,
            }
        },
        data: function () {
            return {
                show:false
            }
        },
        methods:{
            writeMark(){
                let mark = JSON.parse(localStorage.getItem('showTopicSwitchGuide')||"{}") || {};
                mark[this.mark] = "1";
                localStorage.setItem('showTopicSwitchGuide',JSON.stringify(mark))
                this.show = false
            }
        },
        components: { vanPopup },
        mounted() {
            let mark = JSON.parse(localStorage.getItem('showTopicSwitchGuide')||"{}") || {};

            if (mark.hasOwnProperty(this.mark) && "1" === mark[this.mark]){
                this.show = false
            }else {
                this.show = true
            }
        }
    }
</script>
<style lang="scss" scoped>
    .main {
        position: relative;
        img{
            width: 329px;
            height: 343px;
        }
        .know{
            position: absolute;
            bottom: 0;
            left: calc(50% - 75px);
            width: 150px;
            height: 40px;
        }
    }
</style>
